import IcoMoon from 'react-icomoon'
import iconSet from '../Assets/Font/Icomoon/selection.json';
export default function Icon(props) {
  return (
    <IcoMoon iconSet={iconSet} {...props}/>
  )
}